/**
 * Websocket application close codes
 * @public
 */
export enum HoruzProtocolChulakCloseCode {
  // OK codes
  OKAY = 1000,

  // Agent
  AGENT_CANCEL = 4000,
  AGENT_DISCONNECT = 4001,

  // App
  APP_TIMEOUT = 4010,
  APP_CANCEL = 4011,
  APP_ERROR = 4012,
  APP_INVALID_RESPONSE = 4013,

  // Protocol
  PROTOCOL_UNKNOWN_ERROR = 4020,
  PROTOCOL_AUTHENTICATION_TIMEOUT_ERROR = 4021,
  PROTOCOL_AUTHENTICATION_ERROR = 4022,
  PROTOCOL_INVALID_MESSAGE_ERROR = 4023,
}
